import * as betgalaxy from './Exotics.styles.betgalaxy';
import * as betprofessor from './Exotics.styles.betprofessor';
import * as betroyale from './Exotics.styles.betroyale';
import * as fiestabet from './Exotics.styles.fiestabet';
import * as puntcity from './Exotics.styles.puntcity';
import * as puntgenie from './Exotics.styles.puntgenie';
import * as questbet from './Exotics.styles.questbet';
import * as sterlingparker from './Exotics.styles.sterlingparker';
import * as vikingbet from './Exotics.styles.vikingbet';
import * as volcanobet from './Exotics.styles.volcanobet';
import * as wellbet from './Exotics.styles.wellbet';
import * as juicybet from './Exotics.styles.juicybet';
import * as goldenrush from './Exotics.styles.goldenrush';
import * as forsport from './Exotics.styles.forsport';
import * as junglebet from './Exotics.styles.junglebet';
import * as sugarcastle from './Exotics.styles.sugarcastle';
import * as oldgill from './Exotics.styles.oldgill';
import * as buffalobet from './Exotics.styles.buffalobet';
import * as titanbet from './Exotics.styles.titanbet';
import * as slambet from './Exotics.styles.slambet';
import * as gigabet from './Exotics.styles.gigabet';
import * as betstride from './Exotics.styles.betstride';
import * as templebet from './Exotics.styles.templebet';
import * as goldenbet888 from './Exotics.styles.goldenbet888';
import * as hyperbet from './Exotics.styles.hyperbet';
import * as bet777 from './Exotics.styles.bet777';
import * as chromabet from './Exotics.styles.chromabet';
import * as bet575 from './Exotics.styles.bet575';
import * as betblast from './Exotics.styles.betblast';
import * as pyramidbet from './Exotics.styles.pyramidbet';
import * as magnumbet from './Exotics.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
